// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3ZNiS","error":"Textarea_error__3G8NJ","readonly":"Textarea_readonly__15KqN","disabled":"Textarea_disabled__2vJYK"};